import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import Label from 'components/form/Label/Label';
import { ReactComponent as EditIcon } from 'style/_assets/shape.svg';
import { getSimplifiedDate } from 'helpers/dateHelper';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { CSTooltip } from 'components/Tooltip/CSToolTip';
import SSNField from 'components/Fragments/forms/SSNField/SSNField';
import classnames from 'classnames';
import { Image } from '../../../components/Image/Image';
import PhoneNumberFormOneClickApplication from 'partial/OneClickApplicationPersonalInfoModal/components/PhoneNumberFormOneClickApplication';
import './InfoBlock.scss';

const PersonalInfoBlock = props => {
  const {
    ssnForm,
    onChangeEditModal,
    personalInfo,
    ssnError,
    phoneNumberStateList,
    quantityUserPhones,
    setQuantityUserPhones,
  } = props;
  const legalName = `${personalInfo?.firstName} ${
    personalInfo?.middleName ?? ''
  } ${personalInfo?.lastName}`;

  return (
    <FlexContainer className="flex-column width100 m-margl0 margb50 m-margb40">
      <Label typeHeader={'h4'} className="H4 mH5 margb20 m-hide">
        Personal Information
      </Label>
      <Label
        typeHeader={'h4'}
        className="H4 mH5 m-margb0 m-margt12 m-text-16 d-hide"
      >
        Personal Information:
        <EditIcon
          className="fright"
          style={{ width: '24px', height: '24px' }}
          onClick={() => onChangeEditModal(true)}
          aria-label="edit-icon"
        />
      </Label>
      <FlexContainer className="m-flex-column">
        <FlexContainer className="flex-column width100">
          <Label className="Body-1">{legalName}</Label>
          <PersonalAddress personalInfo={personalInfo} />
        </FlexContainer>
        <FlexContainer className="flex-column width100 m-margb16">
          <Label className="Body-1 m-hide">Email: {personalInfo?.email}</Label>
          <Label className="Body-1 m-hide">
            DOB: {getSimplifiedDate(personalInfo?.birthDate)}
          </Label>

          <Label className="Body-1 d-hide">{personalInfo?.email}</Label>
          <Label className="Body-1 d-hide margb16">
            {(personalInfo?.phone?.displayValue ||
              personalInfo?.homePhone?.displayValue ||
              personalInfo?.workPhone?.displayValue) ??
              personalInfo?.contactPhoneNumber}
            <PersonalInfoToolTip
              toolTipText={
                'You authorize Ally to contact you by using any telephone number you provide, including a mobile number that you are authorized to use. In addition to manual calling, Ally may use text messages, prerecorded or artificial voice messages, or automatic dialing systems. Ally will not charge you for any contact, but your mobile phone service provider may.'
              }
            />
          </Label>
        </FlexContainer>
        <FlexContainer className="flex-column width100 align-items-center m-hide">
          <Label
            type="Subtitle-3"
            color="fontBlue100"
            className="otherLink text-16"
            onClick={() => onChangeEditModal(true)}
            style={{ width: '28px', height: '22px' }}
          >
            {'Edit'}
          </Label>
        </FlexContainer>
        <FlexContainer className="flex-column width100 d-hide m-margb16">
          <Label typeHeader={'h4'} className="H4 text-16">
            Date of Birth:
          </Label>
          <FlexContainer>
            {getSimplifiedDate(personalInfo?.birthDate)}
          </FlexContainer>
        </FlexContainer>
      </FlexContainer>

      <FlexContainer className="m-flex-column justify-between">
        <FlexContainer className="flex-column format49 m-format100">
          <FlexContainer className={'flex-column gap-16'}>
            {[...Array(quantityUserPhones?.value)].map((value, index) => {
              return (
                <PhoneNumberFormOneClickApplication
                  key={index}
                  phoneNumberInput={phoneNumberStateList[index]}
                />
              );
            })}
          </FlexContainer>
          <FlexContainer className="flex-column margT16 align-items-start width100">
            {quantityUserPhones?.value < 2 && (
              <Label
                onClick={() =>
                  setQuantityUserPhones({
                    value: quantityUserPhones?.value + 1,
                  })
                }
              >
                <span className="otherLink text-14 fontBlue100">
                  +Add another phone number
                </span>
              </Label>
            )}
            {quantityUserPhones?.value > 1 && (
              <Label
                onClick={() =>
                  setQuantityUserPhones({
                    value: quantityUserPhones?.value - 1,
                  })
                }
              >
                <span className="otherLink text-14 fontBlue100">Delete</span>
              </Label>
            )}
          </FlexContainer>
          <Label
            typeHeader={'h4'}
            className="H4 margt40 m-margt30 margb16 m-margb8 text-16"
          >
            Social Security Number
            <PersonalInfoToolTip
              toolTipText={
                'The last 4 digits of your SSN are needed to confirm your identity.'
              }
            />
          </Label>
          <FlexContainer className="flex-column width100 ">
            <SSNField
              autofocus={false}
              ssn={ssnForm.ssn}
              setSsn={ssnForm.handleSsnChange}
              error={ssnError ? true : false}
              innerLabel={true}
              requiredSsnCharaters={4}
              fullSsn={false}
              hideLock={true}
              placeholder="Last 4 digits"
              className={classnames('format100')}
            />
            {ssnError && (
              <FlexContainer className="margT4 InfoBlock">
                <Image className="errorCircle" />
                <Label className="errorText text-12" role={'alert'}>
                  {ssnError}
                </Label>
              </FlexContainer>
            )}
          </FlexContainer>
        </FlexContainer>
        <FlexContainer className="flex-column format49 m-hide"></FlexContainer>
      </FlexContainer>
    </FlexContainer>
  );
};

const PersonalAddress = props => {
  const { personalInfo } = props;
  const primaryAddress = personalInfo?.primaryAddress;
  const streetAddress = `${primaryAddress?.street}`;
  return (
    <Label className="prequalAddress FlexContainer flex-column ">
      <Label className="Body-1 margB24">
        <Label datatestid="streetReadOnly">{streetAddress}</Label>
        <Label>
          <span data-testid="cityReadOnly" className="toTitleCase">
            {primaryAddress?.city?.toLowerCase()}
          </span>
          {', '}
          <span data-testid="stateReadyOnly">{primaryAddress?.state}</span>
          {', '}
          <span data-testid="zipReadOnly">{primaryAddress?.zip}</span>
        </Label>
      </Label>
    </Label>
  );
};

const PersonalInfoToolTip = ({ toolTipText }) => {
  return (
    <CSTooltip
      vertical={'CREDIT_CARD'}
      title={toolTipText}
      isInline={true}
      className="m-fright"
    >
      <QuestionCircleOutlined
        className="fontGray300"
        style={{
          display: 'inline-block',
          position: 'relative',
          top: -3,
        }}
      />
    </CSTooltip>
  );
};

export default PersonalInfoBlock;
